window.materialIndex = {
  "Bead: Tungsten Bead": {
    url: "/collections/beads"
  },
  "Bead: Tungsten Bead Metallic Black": {
    url: "/products/tungsten-beads-metallic-black"
  },
  "Bead: Tungsten Bead 4.0-5.5mm": {
    url: "/collections/beads"
  },
  "Bead: Tungsten Bead Gold": {
    url: "/products/tungsten-beads-gold"
    },
  "Bead: Slotted Tungsten Bead Gold": {
    url: "/products/slotted-tungsten-bead-gold?_pos=9&_fid=912d6cfca&_ss=c"
  },
  "Bead: Slotted Tungsten Bead Gold 3.0mm": {
    url: "/products/slotted-tungsten-bead-gold?variant=53622679011660"
  },
  "Bead: Slotted Tungsten Bead Metallic Pink 4.0mm": {
    url: "/products/tungsten-beads-metallic-light-pink?variant=53622652797260"
  },
  "Bead: 3.5mm Slotted Metallic Light Pink": {
    url: "/products/tungsten-beads-metallic-light-pink?variant=53622652764492"
  },
  "Bead: Slotted Tungsten Bead Black Nickel": {
    url: "/products/slotted-tungsten-bead-black-nickel?variant=53622701359436"
  },
  "Bead: Slotted Tungsten Bead": {
    url: "/collections/beads?filter.p.m.custom.bead_type=Slotted"
  },
  "Bead: Tungsten Bead": {
    url: "/collections/beads"
  },
  "Krok: Dry Fly Hook, size 12-16": {
    url: "/collections/krokar-beads"
  },
  "Krok: Hanak H900BL Streamer": {
    url: "/products/hanak-h900bl-streamer"
  },
  "Krok: Hanak H130BL Dry Fly": {
    url: "/products/hanak-dry-fly?variant=53147866267980"
  },
  "Krok: Hanak Klinkhammer": {
    url: "/products/hanak-h390bl-klinkhammer?variant=53211256193356"
  },
  "Krok: Fulling Mill FM-2225 Stealth Streamer": {
    url: "/products/stealth-streamer-fm-2225?variant=53211222704460"
  },
  "Krok: Fulling Mill Czech Nymph #14": {
    url: "/products/fulling-mill-czech-nymph-hullinglos?variant=53205731017036"
  },
  "Krok: Fulling Mill FM-5050 Dry Fly": {
    url: "/products/ultimate-dry-fly-black-nickel?variant=53205728723276"
  },
  "Krok: Fulling Mill FM-5050 #14": {
    url: "/products/ultimate-dry-fly-black-nickel?variant=53205728723276"
  }, 
  "Krok: Fulling Mill FM-5045 Jig Force": {
    url: "/products/jig-force-hullinglos-fm-5045?variant=53210923336012"
  },
  "Krok: Fulling Mill Jig Force": {
    url: "/products/jig-force-hullinglos-fm-5045?variant=53210923336012"
  },
  "Krok: Fulling Mill Jig Force #16": {
    url: "/products/jig-force-hullinglos-fm-5045?variant=53210923336012"
  },
  "Krok: Fulling Mill FM-5025 Grab Gape": {
    url: "/products/fm5025-grab-gape?_pos=1&_psq=grab&_ss=e&_v=1.0"
  },
  "Krok: Fulling Mill FM-1135 Lightweight Grub": {
    url: "/products/lightweight-grub-fm-1135?_pos=1&_psq=lightweight&_ss=e&_v=1.0"
  }, 
  "Krok: Demmon J100 BL Jig Hook": {
    url: "/products/supreme-competition-j100-bl-jig-hook?variant=55787662278988"
  }, 
  "Krok: Demmon C400 Caddis Hook": {
    url: "/products/supreme-competition-c400-bl-caddis-hook?variant=55938438431052"
  }, 
  "Krok: Demmon G602 BL": {
    url: "/products/demmon-competition-g602-bl-fly-hook?variant=53437068247372"
  },
  "Krok: Demmon D201 BL Dry Hook": {
    url: "/products/demmon-supreme-competition-d201-bl-dry-hook?_pos=1&_psq=d201&_ss=e&_v=1.0"
  },
  "Krok: Demmon Supreme Competition D201": {
    url: "/products/demmon-supreme-competition-d201-bl-dry-hook?_pos=1&_psq=d201&_ss=e&_v=1.0"
  },
  "Krok: Demmon DJS 315BL #14": {
    url: "/products/demmon-djs-315-bl-fly-jig-hook?variant=53436715991372"
  },
  "Krok: Firehole Sticks 413": {
    url: "/products/firehole-sticks™-413?variant=56495277801804"
  },
  "Krok: Firehole Sticks 413 #14": {
    url: "/products/firehole-sticks™-413?variant=56495277801804"
  },
  "Bindtråd: Sumo Power Thread 100DEN": {
    url: "/products/sumo-power-thread-100den-100m?_pos=1&_psq=100den&_ss=e&_v=1.0"
  },
  "Bindtråd: Sumo Power Thread 100DEN, Black": {
    url: "/products/sumo-power-thread-100den-100m?_pos=1&_psq=sumo&_ss=e&_v=1.0"
  },
  "Bindtråd: Sumo Power Thread 30DEN": {
    url: "/products/sumo-power-thread-30den-100m?_pos=1&_psq=30den&_ss=e&_v=1.0"
  },
  "Bindtråd: Sumo Power Thread 50DEN": {
    url: "/products/sumo-power-thread-50den-100m?variant=55843107537228"
  },
  "Bindtråd: Sumo Power Thread 50DEN, Yellow": {
    url: "/products/sumo-power-thread-50den-100m?variant=55843107602764"
  },
  "Bindtråd: Champion Thread 8/0": {
    url: "/products/champion-thread-8-0?_pos=2&_psq=champion+thread&_ss=e&_v=1.0"
  },
  "Bindtråd: Champion Thread 6/0": {
    url: "/products/champion-thread-6-0"
  },
  "Bindtråd: Nano Silk 30D 18/0, White": {
    url: "/products/nano-silk-30d-18-0?variant=55939646325068"
  },
  "Bindtråd: Nano Silk 50D": {
    url: "/products/nano-silk-50d-12-0?_pos=3&_psq=nano+silk&_ss=e&_v=1.0"
  },
  "Bindtråd: Nano Silk 50D, Yellow": {
    url: "/products/nano-silk-50d-12-0?variant=56217688506700"
  },
  "Bindtråd: Nano Silk 50D 12/0, Yellow": {
    url: "/products/nano-silk-50d-12-0?variant=56217688506700"
  },
  "Bindtråd: Nano Silk 50DEN": {
    url: "/products/nano-silk-50d-12-0?_pos=3&_psq=nano+silk&_ss=e&_v=1.0"
  },
  "Bindtråd: Nano Silk 30D 18/0": {
    url: "/products/nano-silk-30d-18-0"
  },
  "Bindtråd: Nano Silk 30D": {
    url: "/products/nano-silk-30d-18-0"
  },
  "Bindtråd: Nano Silk 30DEN": {
    url: "/products/nano-silk-30d-18-0"
  },
  "Bindtråd: Nano Silk 30D, Black": {
    url: "/products/nano-silk-30d-18-0?_pos=1&_psq=30d&_ss=e&_v=1.0"
  },
  "Bindtråd: Nano Silk 30D, White": {
    url: "/products/nano-silk-30d-18-0?variant=55939646325068"
  },
  "Bindtråd: UNI-Thread, Grey": {
    url: "/collections/bindtrad?filter.p.vendor=UNI%20Products"
  },
  "Extra vikt: Lead-Free Wire": {
    url: "/products/round-lead-free-wire?variant=53543400046924"
  },
  "Stjärt: Wolly Bugger Marabou": {
    url: "/products/marabou-strung-blood-quills?_pos=1&_psq=wolly+bugger&_ss=e&_v=1.0"
  },
  "Stjärt: Red Marabou": {
    url: "/products/premium-marabou-blood-quills?_pos=2&_fid=13e94d078&_ss=c"
  },
  "Stjärt: Coq De Leon Pardo Colgaderas": {
    url: "/products/coq-de-leon-pardo-colgaderas?_pos=1&_psq=coq+de+leon&_ss=e&_v=1.0&variant=53655026336076"
  },
  "Stjärt: Coq De Leon Rihnon, Pardo Flor De Escoba": {
    url: "/products/coq-de-leon-pardo-colgaderas?_pos=1&_psq=coq+de+leon&_ss=e&_v=1.0&variant=53655026336076"
  },
  "Kropp: Cactus Chenille 6mm": {
    url: "/products/cactus-chenille?_pos=1&_psq=cactus+chenille&_ss=e&_v=1.0"
  },
  "Hackel: Streamer Straggle": {
    url: "/products/streamer-straggle-uv?_pos=1&_psq=streamer+stragg&_ss=e&_v=1.0"
  },
  "Kropp: Voodoo Streamer Dub": {
    url: "/voodoo-streamer-dub?_pos=1&_psq=voodoo&_ss=e&_v=1.0"
  },
  "Kropp: Hareline Ice Dub": {
    url: "/products/ice-dubbing?_pos=1&_psq=ice+dub&_ss=e&_v=1.0"
  },
  "Kropp: Suede Chenille": {
    url: "/products/suede-floating-chenille?variant=56221009183052"
  },
  "Kropp: Zonker Strip": {
    url: "/collections/hackel?filter.p.product_type=Zonker"
  },
  "Kropp: Zonker Strip": {
    url: "/collections/hackel?filter.p.product_type=Zonker"
  },
  "Kropp: Mylar Cord": {
    url: "/products/mylar-cord?_pos=1&_psq=mylar&_ss=e&_v=1.0"
  },
  "Kropp: Mylar Tinsel": {
    url: "/products/mylar-tinsel-gold-silver"
  },
  "Kropp: Tactical Dry Fly Dub, Grey Olive": {
    url: "/products/tactical-dry-fly-dub?variant=58672636690764"
  },
  "Kropp: Mad Rabbit Dubbing, Natural": {
    url: "/products/mad-rabbit-dubbing?variant=53489514119500"
  },
  "Kropp: Squirrel Hybrid Dubbing": {
    url: "/products/squirrel-hybrid-dubbing?_pos=1&_psq=squirrel+hybrid&_ss=e&_v=1.0"
  },
  "Kropp: Squirrel Hybrid Dubbing, Natural Grey": {
    url: "/products/squirrel-hybrid-dubbing?variant=57123334685004"
  },
  "Kropp: Squirrel Hybrid Dubbing, Black Pepper": {
    url: "/products/squirrel-hybrid-dubbing?_pos=2&_psq=black+pepper&_ss=e&_v=1.0&variant=53555809124684"
  },
  "Kropp: Snowshoe Rabbit Dubbing, Olive": {
    url: "/products/nature-s-spirit-snowshoe-rabbit-foot-dubbing?_pos=1&_psq=snowhoe&_ss=e&_v=1.0"
  },
  "Kropp: Snowshoe Rabbit Dubbing, Muskrat Gray": {
    url: "/products/nature-s-spirit-snowshoe-rabbit-foot-dubbing?variant=53206026092876"
  },
  "Kropp: Snowshoe Rabbit Dubbing, Brown": {
    url: "/products/nature-s-spirit-snowshoe-rabbit-foot-dubbing?variant=53206026158412"
  },
  "Kropp: Peacock Herl": {
    url: "/products/peacock-herl?_pos=2&_psq=peacock&_ss=e&_v=1.0"
  },
  "Kropp: Super Fine Dubbing": {
    url: "/products/super-fine-dubbing?variant=53203613221196"
  },
  "Kropp: Kapok Dubbing": {
    url: "/products/kapok-dubbing?_pos=1&_psq=kapok&_ss=e&_v=1.0"
  },
  "Kropp: Pheasant Rooster Middle Tail": {
    url: "/products/pheasant-rooster-middle-tail?variant=53662749622604"
  },
  "Kropp: Pheasant Rooster Middle Tail, Black": {
    url: "/pheasant-rooster-middle-tail?_pos=1&_psq=rooster&_ss=e&_v=1.0"
  },
  "Kropp: Stripped Peacock Quill, Green": {
    url: "/products/stripped-peacock-quill?variant=53447368507724"
  },
  "Kropp: Pure Squirrel Dubbing": {
    url: "/products/premium-pure-squirrel-dubbing?_pos=1&_psq=pure+squirrel&_ss=e&_v=1.0&variant=53540414226764"
  },
  "Kropp: Pure Squirrel Dubbing, Eastern Grey": {
    url: "/products/premium-pure-squirrel-dubbing?variant=55938540929356"
  },
  "Krage: Pure Squirrel Dubbing Eastern Grey": {
    url: "/products/premium-pure-squirrel-dubbing?variant=55938540929356"
  },
  "Kropp: Mojo Nymph Yarn, Tan": {
    url: "/products/mojo-nymph-yarn-300den-10m?variant=53436664676684"
  },
  "Kropp: Mojo Nymph Yarn, Yellow": {
    url: "/products/mojo-nymph-yarn-300den-10m?variant=53436664709452"
  },
  "Kropp: Beaver Dry Fly Dubbing": {
    url: "/products/beaver-dry-fly-dubbing?variant=53563315978572"
  },
  "Kropp: Beaver Dry Fly Dubbing, Olive": {
    url: "/products/beaver-dry-fly-dubbing?_pos=1&_psq=beaver+dr&_ss=e&_v=1.0"
  },
  "Kropp: Super Fine Dubbing, Pale Yellow": {
    url: "/products/super-fine-dubbing?_pos=1&_psq=super+fine&_ss=e&_v=1.0"
  },
  "Kropp: Super Fine Dubbing, Brown": {
    url: "/products/super-fine-dubbing?variant=53203613221196"
  },
  "Kropp: Super Fine Dubbing, Grey": {
    url: "/products/super-fine-dubbing?variant=53203613778252"
  },
  "Kropp: Mojo Nymph Yarn": {
    url: "/products/mojo-nymph-yarn-300den-10m?_pos=1&_psq=mojo&_ss=e&_v=1.0"
  },
  "Kropp: Spinning Deer Hair": {
    url: "/products/spinning-deer-hair?variant=53387316429132"
  },
  "Kropp: Perdigon Skin": {
    url: "/products/perdigon-skin-small?_pos=1&_psq=perdigon+skin&_ss=e&_v=1.0"
  },
  "Kropp: Super Suede Chenille, Olive": {
    url: "/products/super-suede-chenille?_pos=1&_psq=super+sue&_ss=e&_v=1.0"
  },
  "Kropp: Thorax Nymph Dubbing, Light": {
    url: "/products/thorax-nymph-dubbing?variant=55925762720076"
  },
  "Kropp: Foam Cylinder, Tan": {
    url: "/products/foam-cylinders-2-8mm?_pos=1&_psq=foam+cy&_ss=e&_v=1.0"
  },
  "Kropp: Premium Dyed CDC Feathers, Grey Dun": {
    url: "/products/premium-dyed-cdc-feathers-5cm?variant=56186672447820"
  },
  "Kropp: CDC Super Select, Khaki Campell": {
    url: "/products/cdc-feathers-super-select?variant=57431529357644"
  },
  "Kropp: Klingberg Bug Yarn": {
    url: "/products/klingberg-bug-yarn?_pos=1&_psq=klingber&_psid=03cb75e03&_ss=e"
  },
  "Ben: Deer Hair Short, Olive": {
    url: "/products/deer-hair-short-fine?variant=56476479652172"
  },
  "Ribbing: Ultra Wire Small, Silver": {
    url: "/products/ultra-wire-small?variant=55787693113676"
  },
  "Ribbing: Ultra Wire": {
    url: "/products/ultra-wire-small?variant=53310551097676"
  },
  "Ribbing: UV Micro Ribbing Quill": {
    url: "/products/uv-micro-ribbing-quill?_pos=2&_psq=micro&_ss=e&_v=1.0"
  },
  "Ribbing: UV Micro Ribbing Quill, Pink": {
    url: "/products/uv-micro-ribbing-quill?variant=53655228744012"
  },
  "Ribbing: UV Micro Ribbing Quill, Brown": {
    url: "/products/uv-micro-ribbing-quill?variant=53655228842316"
  },
  "Ribbing: UV Ribbing Fibers, Pink": {
    url: "/products/uv-ribbing-fibers?variant=57710079410508"
  },
  "Ribbing: French Tinsel Oval": {
    url: "/products/french-oval-tinsel?variant=56309524005196"
  },
  "Ribbing: Perdigon UV Flat Tinsel, Peacock": {
    url: "/products/perdigon-uv-flat-tinsel?variant=56186738671948"
  },
  "Ribbing: UNI-Floss, Hot Pink": {
    url: "/products/uni-floss-neon?variant=53353990226252"
  },
  "Stjärt: Deer Hair": {
    url: "/products/deer-hair-short-fine?_pos=2&_sid=4e421ac76&_ss=r"
  },
  "Stjärt: Coq de Leon Pardo Colgaderas": {
    url: "/products/coq-de-leon-pardo-colgaderas?variant=53528996217164"
  },
  "Stjärt: Pheasant Rooster Middle Tail": {
    url: "/products/pheasant-rooster-middle-tail?variant=53662749557068"
  },
  "Stjärt: Coq de Leon Langareta De Verano": {
    url: "/products/coq-de-leon-pardo-colgaderas?variant=53655026336076"
  },
  "Stjärt: Moose Mane": {
    url: "/products/moose-mane?_pos=1&_psq=moose+mane&_ss=e&_v=1.0"
  },
  "Nedre vinge: Yellow Bucktail": {
    url: "/products/bucktail?variant=55787692753228"
  },
  "Undervinge: CDC, Grey Dun": {
    url: "/products/premium-dyed-cdc-feathers-5cm?variant=56186672447820"
  },
  "Mittvinge: Red Bucktail": {
    url: "/products/bucktail?variant=55787692720460"
  },
  "Övre vinge: Yellow Bucktail": {
    url: "/products/bucktail?variant=55787692753228"
  },
  "Vinge: Mallard Breast Feather": {
    url: "/products/mallard-breast-feathers?_pos=1&_psq=mallard&_ss=e&_v=1.0"
  },
  "Vinge: Polypropolene Yarn": {
    url: "/products/polypropylene-floating-yarn?variant=53310483890508"
  },
  "Vinge: Polypropolene Yarn, Cream": {
    url: "/products/polypropylene-floating-yarn?variant=53310483923276"
  },
  "Vinge: Selected Cow Elk": {
    url: "/products/select-cow-elk?variant=56145148805452"
  },
  "Vinge: Selected Cow Elk, Bleached": {
    url: "/products/select-cow-elk?variant=56145148805452"
  },
  "Vinge: Selected CDC Wild European Mallard": {
    url: "/products/utvald-cdc-fran-wild-european-mallard?_pos=3&_psq=cdc&_ss=e&_v=1.0"
  },
  "Vinge: English Partridge, Natural Grey": {
    url: "/products/english-partridge?_pos=1&_psq=partridge&_ss=e&_v=1.0"
  },
  "Vinge: Ultra Dry Yarn": {
    url: "/products/ultra-dry-yarn?variant=56268303925580"
  },
  "Vinge: Ultra Dry Yarn, Dark Dun": {
    url: "/products/ultra-dry-yarn?variant=56268303925580"
  },
  "Vinge: Deer Hair Short": {
    url: "/products/deer-hair-short-fine?_pos=2&_fid=1524f018f&_ss=c"
  },
  "Vinge: All Purpose Deer Hair": {
    url: "/products/all-purpose-deer-hair?variant=57582018462028"
  },
  "Vinge: Deer Hair Short Fine, Natural Brown": {
    url: "/products/deer-hair-short-fine?variant=56145141236044"
  },
  "Vinge: CDC Super Select, Khaki Campell": {
    url: "/products/cdc-feathers-super-select?variant=57431529357644"
  },
  "CDC: Selected CDC Wild European Mallard": {
    url: "/products/utvald-cdc-fran-wild-european-mallard?_pos=1&_psq=wild&_ss=e&_v=1.0"
  },
  "Hackel: Dry Fly Hackle": {
    url: "/collections/nackar-sadlar"
  },
  "Hackel: Half Cape, Grizzly": {
    url: "/products/half-cape?_pos=1&_psq=half+cape&_ss=e&_v=1.0"
  },
  "Thorax: Peacock Herl": {
    url: "/products/peacock-herl?_pos=2&_psq=peacock&_ss=e&_v=1.0"
  },
  "Thorax: Super Fine Dubbing": {
    url: "/products/super-fine-dubbing?_pos=1&_psq=super+fine&_ss=e&_v=1.0"
  },
  "Thorax: Pure Squirrel Dubbing, Black Pepper": {
    url: "/products/premium-pure-squirrel-dubbing?variant=53540414554444"
  },
  "Thorax: Squirrel Hybrid Dubbing": {
    url: "/products/squirrel-hybrid-dubbing?_pos=1&_psq=squirrel+hybr&_ss=e&_v=1.0"
  },
  "Thorax: Squirrel Hybrid Dubbing, Black Pepper": {
    url: "/products/squirrel-hybrid-dubbing?_pos=2&_psq=squirre&_ss=e&_v=1.0"
  },
  "Thorax: UV Spectra Dubbing, Pink": {
    url: "/products/uv-spectra-dubbing?variant=56186707575116"
  },
  "Thorax: CDC Super Select, Pardo": {
    url: "/products/cdc-feathers-super-select?variant=57431529390412"
  },
  "Collar: Hot Spot Thread, Fluo Orange": {
    url: "/products/hot-spot-thread-160den-100m?variant=53449084469580"
  },
  "Collar: Hot Spot Thread": {
    url: "/products/hot-spot-thread-160den-100m?variant=53449084469580"
  },
  "Collar: Pure Squirrel Dubbing, Eastern Grey": {
    url: "/products/premium-pure-squirrel-dubbing?variant=55938540929356"
  },
  "Collar: Pure Squirrel Dubbing, Natural Grey": {
    url: "/products/premium-pure-squirrel-dubbing?variant=53540414390604"
  },
  "Collar: Pure Squirrel Dubbing, Rusty Brown": {
    url: "/products/premium-pure-squirrel-dubbing?variant=53540414521676"
  },
  "Kroppsaccent: Champion Thread 8/0": {
    url: "/products/champion-thread-8-0"
  },
  "Limning: UV Resin-Clear Finish": {
    url: "/products/uv-resin-clear-finish?_pos=2&_psq=uv+resin+clear&_ss=e&_v=1.0"
  },
  "Limning: UV Resin Clear Resin-Thin": {
    url: "/products/uv-resin-clear-resin-thin"
  },
  "Limning: Zap A Gap Brush On": {
    url: "/products/zap-a-gap-brush-on?_pos=1&_psq=zap+a+gap&_ss=e&_v=1.0"
  },
  "Lim: Zap A Gap": {
    url: "/products/zap-a-gap-brush-on?_pos=1&_psq=zap+a+gap&_ss=e&_v=1.0"
  },
  "Dubbing: Mad Rabbit Dubbing": {
    url: "/products/mad-rabbit-dubbing?variant=53489514119500"
  }, 
  "Dubbing: Kapok Dubbing, March Brown": {
    url: "/products/kapok-dubbing?variant=53437273211212"
  },
  "Dubbing: Premium Pure Squirrel": {
    url: "/products/premium-pure-squirrel-dubbing?variant=53540414390604"
  },
  "Dubbing: Squirrel Hybrid Dubbing, Natural Pine": {
    url: "/products/squirrel-hybrid-dubbing?variant=57124438901068"
  },
  "Dubbing: Super Fine Dubbing, Black": {
    url: "/products/super-fine-dubbing?variant=53203613647180"
  },
  "Foam: Foam Cylinders 2.8mm, Tan": {
    url: "/products/foam-cylinders-2-8mm?variant=56476221210956"
  },
  "Foam: Bug Foam 2.0mm": {
    url: "/products/bug-foam-2mm?_pos=1&_psq=bug+foam&_psid=0a92ccbd6&_ss=e"
  },
  "Wing Case: Pheasant Tail": {
    url: "/products/pheasant-cock-ringneck-centre-tails?_pos=3&_psq=pheasant&_ss=e&_v=1.0"
  },
  "Verktyg: Extended Body Tool": {
    url: "/products/detached-body-tool?_pos=1&_psq=detached&_ss=e&_v=1.0"
  },
  "Verktyg: Detached Body Tool": {
    url: "/products/detached-body-tool?_pos=1&_psq=detached&_ss=e&_v=1.0"
  },
  "Verktyg: Color Marker": {
    url: "/products/color-markers?_pos=1&_psq=color&_psid=a5475cb5c&_ss=e"
  },
  "Ägg: Hot Spot Thread, Chartreuse": {
    url: "/products/hot-spot-thread-160den-100m?variant=53449084535116"
  },                        

};